import { Controller } from 'stimulus';

class SidebarBookingFormController extends Controller {
  connect() {
    this.amountOfPersons = 2;
    this.desiredDateOfArrival = this.data.get('desired-date-of-arrival');
    this.firstAvailableDate = this.data.get('first-available-date');

    this.toggleNotification(this.desiredDateOfArrival >= this.firstAvailableDate);
  }

  // eslint-disable-next-line class-methods-use-this
  onVariantChange(e) {
    const { url } = e.currentTarget.dataset;
    const searchParams = new URLSearchParams(window.location.search);

    window.location = `${url}?${searchParams}`;
  }

  onChangeJourney(event) {
    const url = event.currentTarget.getAttribute('data-url');

    setTimeout(() => {
      window.location.href = url;
    }, 100);
  }

  updateDatePicker() {
    const datePickerControllerEl = document.querySelector('[data-controller*="datepicker"]');
    const datePickerController = this.application.getControllerForElementAndIdentifier(datePickerControllerEl, 'datepicker');

    datePickerController.amountOfPersons = this.amountOfPersons;

    datePickerController.updateDatePicker();
  }

  getAmountOfPersons() {
    const amountOfAdults = parseInt(this.amountOfAdultsTarget.value, 10);
    const amountOfChildren = parseInt(this.amountOfChildrenTarget.value, 10);

    return amountOfAdults + amountOfChildren;
  }

  enableSubmitButton() {
    if (!this.hasSubmitButtonTarget) return;

    this.submitButtonTarget.disabled = false;
  }

  disableSubmitButton() {
    if (!this.hasSubmitButtonTarget) return;

    this.submitButtonTarget.disabled = true;
  }

  toggleNotification(state) {
    if (!this.hasNotificationTarget) return;

    this.notificationTarget.style.display = !state ? 'block' : 'none';
  }
}

SidebarBookingFormController.targets = [
  'notification',
  'submitButton',
  'amountOfAdults',
  'amountOfChildren',
];

export default SidebarBookingFormController;
